import { setViewBox } from '%paysera_seat_selection_integration/js/seatings/redux';
import selectHall from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/selectHall';
import { SEATING_MAP_PADDING } from '%paysera_seat_selection_integration/js/seatings/Page/config/constants';
import setViewBoxSlider from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setViewBoxSlider';

function fitHallIntoViewBox() {
    return (dispatch, getState) => {
        const {
            polygon: {
                points: [p0],
                dimensions: { width, height },
            },
        } = selectHall(getState());

        const viewBox = {
            coordinates: {
                x: Math.sign(p0.x) * (Math.abs(p0.x) - (SEATING_MAP_PADDING * Math.sign(p0.x))),
                y: Math.sign(p0.y) * (Math.abs(p0.y) - (SEATING_MAP_PADDING * Math.sign(p0.y))),
            },
            width: width + SEATING_MAP_PADDING * 2,
            height: height + SEATING_MAP_PADDING * 2,
        };

        dispatch(setViewBox(viewBox));

        const controlValue = Math.ceil((width > height ? width : height) * 1.5 / 10) * 10;
        const min = controlValue / 10;
        const max = controlValue + controlValue / 10;
        const viewBoxSlider = {
            min,
            max,
            step: (max - min) / 100,
        };

        dispatch(setViewBoxSlider(viewBoxSlider));
    };
}

export default fitHallIntoViewBox;
